export const scrollUp = () => {
  // 'app' is the root element of the react app (see index.html)
  document.getElementById('app')?.scrollIntoView({
    block: 'start',
    inline: 'start',
    behavior: 'smooth',
  });
};
